export class RevealHandler {
    constructor() {
        this.items = document.querySelectorAll('[jss="reveal"]');
        this.observerOptions = {
            root: null,
            rootMargin: "0px 0px -10% 0px",
            threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        };
        this.itemObserver = new IntersectionObserver((entries, observer) => this.onIntersectObserver(entries, observer), this.observerOptions);
        this.items.forEach((item) => {
            if (item instanceof HTMLElement) {
                this.itemObserver.observe(item);
                let secondaryItem = item.parentNode.querySelector('[jss="after-reveal"]');
                if (secondaryItem instanceof HTMLElement) {
                    secondaryItem.style.opacity = "0";
                    secondaryItem.style.visibility = "hidden";
                }
            }
        });
    }
    onIntersectObserver(entries, observer) {
        const self = this;
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                if (entry.target instanceof HTMLElement) {
                    let item = entry.target;
                    self.tryReveal(item, entry);
                }
                else {
                }
            }
            else {
            }
        });
    }
    tryReveal(item, entry) {
        if (entry.boundingClientRect.top < 0) {
            this.reveal(item, "top");
        }
        else if (entry.intersectionRatio > 0.85) {
            this.reveal(item, "fade");
        }
        else {
            this.reveal(item, "bottom");
        }
        this.itemObserver.unobserve(item);
    }
    reveal(item, directionTo) {
        if (item instanceof HTMLElement) {
            if (directionTo == "top") {
                item.style.bottom = "100%";
            }
            else if (directionTo == "bottom") {
                item.style.top = "100%";
            }
            else {
                item.style.opacity = "0";
            }
            item.addEventListener("transitionend", () => {
                let secondaryItem = item.parentNode.querySelector('[jss="after-reveal"]');
                if (secondaryItem instanceof HTMLElement) {
                    secondaryItem.style.opacity = "1";
                    secondaryItem.style.visibility = "";
                }
                item.remove();
            });
        }
    }
}
